const motivation = [
  { id: 1, text: 'motivation.assessment' },
  { id: 2, text: 'motivation.assistance' },
  { id: 3, text: 'motivation.securityCheck' },
  { id: 4, text: 'motivation.availableCheck' },
  { id: 5, text: 'motivation.parkingCheck' },
  { id: 6, text: 'motivation.OBUCheck' }
]

export default motivation
